import { defaultLocale, locales } from "@/i18n/config";

export const withLocalePrefix = (href: string, locale: string): string => {
  if (!href.startsWith("/") || href.startsWith("//")) {
    return href;
  }

  const firstSegment = href.split("/")[1];
  if ((locales as readonly string[]).includes(firstSegment)) {
    return href;
  }

  if (locale === defaultLocale) {
    return href;
  }

  return `/${locale}${href}`;
};
